/* eslint-disable promise/prefer-await-to-callbacks */
import React from 'react';

RegExp.escapeString = (string) => {
  if (!string) return;

  return String(string).replace(/([!$()*+/:=?[\\\]^{|}])/g, '\\$1');
};

export const validateEmail = (email) => {
  // We scape the input to avoid Dos
  const textToReview = RegExp.escapeString(email);
  const emailRegex = /^[^\s@]+@[\w-.]+\.\w{2,}$/;

  return emailRegex.test(textToReview);
};

export const validatePasswordRules = (value, config) => {
  const errors = [];

  if (!value) {
    errors.push('Password is required');

    return errors;
  }

  for (const rule of config.rules) {
    try {
      if (!rule.test(value)) {
        errors.push(rule.message);
      }
    } catch (error) {
      console.warn(`Error in password rule '${rule.type}':`, error);
    }
  }

  return errors;
};

/** Valdate postcode by regex
 *
 * @param {string} postCode - The postcode to validate
 * @returns {boolean}
 */
export const validatePostCode = (postCode) => {
  const codeToReview = RegExp.escapeString(postCode);
  const regex = /^[a-z]{1,2}\d[\da-z]?\s?\d[a-z]{2}$/i;

  return regex.test(codeToReview);
};

export const validateName = (name) => {
  const value = RegExp.escapeString(name);

  return /^([^\d\n!"#$%&()*+,/:;<=>?@[\\\]^_`{|}~£¬]+)$/.test(value);
};

export const validatePhone = (number) => {
  const value = RegExp.escapeString(number);

  return /^\+?(\s*\d){9,20}\s*$/.test(value);
};

export const validateNumber = (number) => {
  const value = RegExp.escapeString(number);

  return /^\d+$/i.test(value);
};

export const validateCharacter = (char) => {
  const value = RegExp.escapeString(char);

  return /^[\da-z-]*$/i.test(value);
};

/**
 * Renders password validation errors from a delimited error string.
 *
 * @param errorString - A string with errors separated by "|" or ",".
 * @param delimiter - Optional custom delimiter. Default is "|".
 * @returns ReactNode - either a list of <li> errors or the raw string.
 */
export function renderPasswordErrors(errorString, delimiter = '|') {
  if (!errorString) return null;

  const errors = errorString
    .split(delimiter)
    .map((error) => error.trim())
    .filter(Boolean);
  console.log(errors, 'Password Errors');

  if (errors.length <= 1) return errorString;

  return (
    <div>
      {errors.map((error, index) => (
        <li key={`password-bp-${index}`}>{error}</li>
      ))}
    </div>
  );
}
